<nav class="subnav">
  <ul class="nav">
    <li class="nav-item">
      <a class="nav-link" [routerLink]="['/contacts/overview']">Übersicht</a>
    </li>
    <li class="nav-item">
      <a class="nav-link active" [routerLink]="['/contacts/customer']">Kunden</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" [routerLink]="['/contacts/suppliers']">Lieferanten</a>
    </li>
  </ul>
</nav>

<main>
  <h2>PHM PPS  <cds-icon shape="two-way-arrows"></cds-icon>  Kunden</h2>
  <a *ngIf="!devMode" class="btn btn-primary btn-sm" [routerLink]="['/contact/add']">Neue Firma</a>
  <clr-datagrid [clrDgLoading]="loading">
    <clr-dg-column [clrDgField]="'cid'">ID</clr-dg-column>
    <clr-dg-column [clrDgField]="'company'" [clrDgSortOrder]="descSort">Firma</clr-dg-column>
    <clr-dg-column [clrDgField]="'department'" [clrDgSortOrder]="descSort">Abteilung</clr-dg-column>
    <clr-dg-column [clrDgField]="'classification'">Klass.</clr-dg-column>
    <clr-dg-column [clrDgField]="'nda'">NDA</clr-dg-column>
    <clr-dg-column [clrDgField]="'postcode'">PLZ</clr-dg-column>
    <clr-dg-column [clrDgField]="'city'">Ort</clr-dg-column>
    <clr-dg-column [clrDgField]="'country'">Land</clr-dg-column>
    <clr-dg-column>Telefon</clr-dg-column>
    <clr-dg-column>E-Mail</clr-dg-column>
    <clr-dg-placeholder>We couldn't find any Contact!</clr-dg-placeholder>
    <clr-dg-row *clrDgItems="let company of companies" [routerLink]="['/contact/details', company.cid ]">
      <clr-dg-cell>{{ company.cid }}</clr-dg-cell>
      <clr-dg-cell><button *ngIf="!company.active" class="btn btn-warning btn-sm">PASSIV!</button><b>{{ company.company }}</b></clr-dg-cell>
      <clr-dg-cell>{{ company.department }}</clr-dg-cell>
      <clr-dg-cell>{{ company.classification }}</clr-dg-cell>
      <clr-dg-cell *ngIf="company.nda">ja</clr-dg-cell> <clr-dg-cell *ngIf="!company.nda">nein</clr-dg-cell>
      <clr-dg-cell>{{ company.postcode }}</clr-dg-cell>
      <clr-dg-cell>{{ company.city }}</clr-dg-cell>
      <clr-dg-cell>
        <ng-container *transloco="let t; prefix: 'countries'">
          {{ company.country?.length === 2 ? t(company.country ?? '') : (company.country ?? '') }}
        </ng-container>
      </clr-dg-cell>
      <clr-dg-cell class="nowrap">{{ company.phone }}</clr-dg-cell>
      <clr-dg-cell>{{ company.email }}</clr-dg-cell>
    </clr-dg-row>
    <clr-dg-footer>
      <clr-dg-pagination #pagination [clrDgPageSize]="50">
        <clr-dg-page-size [clrPageSizeOptions]="[10,25,50,100]">Firmen pro Seite</clr-dg-page-size>
        {{pagination.firstItem + 1}} - {{pagination.lastItem + 1}}
        von {{companies.length}} Kontakt(en)
      </clr-dg-pagination>
    </clr-dg-footer>
  </clr-datagrid>
</main>
